import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {lastValueFrom, Observable, Subject, takeUntil} from 'rxjs';
import {CommonService} from "../services/common.service";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../state/app.state";
import {v1URL} from "../constants/urls.constants";
import {roleUrlMap, step} from "../constants/common.constants";
import {HttpClient} from "@angular/common/http";
import {phoneNumber} from "../../authentication/core/authentication.selectors";
import {SetProfile} from "../core/shared.actions";
import {
  StartRegistrationLoading,
  StopRegistrationLoading
} from "../../authentication/core/authentication.actions";

@Injectable({
  providedIn: 'root'
})
export class RegisterStepThreeGuard {
  onGoingStep: number;
  url: string;
  method: string;
  urlSuffix = '';
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private router: Router,
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
    private http?: HttpClient,
  ) {
  }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree> {
    let response: any;

    const removeOnboardingTokens = () => {
      this.commonService.removeRegisterToken();
      this.commonService.removeRegisterOtpToken();
      this.commonService.removeOnboardingToken();
    }

    this.store
      .select(phoneNumber)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data?.phoneNumber !== '') {
          this.url = v1URL.user.registration['onboarding-step'].url;
          this.method = v1URL.user.registration['onboarding-step'].method;
        } else {
          this.urlSuffix = '?stepBack=true';
          this.url = v1URL.user.registration['onboarding-step'].url;
          this.method = v1URL.user.registration['onboarding-step'].method;
        }
      });
    this.store.dispatch(StartRegistrationLoading());
    response = await lastValueFrom(this.http[this.method](this.url + this.urlSuffix));
    removeOnboardingTokens();
    const onGoingStep = response.data.onGoingStep;
    if (response.data) {
      this.commonService.setOnboardingToken(response.data.token);
      if (onGoingStep === step["step-3"]) {
        this.store.dispatch(StopRegistrationLoading());
        return true;
      }

      if (onGoingStep === step["step-2"]) {
        this.router.navigate(['/auth/register/step-2']);
        return false;
      }
    }

    if (onGoingStep === step['step-6']) {
      if (response.data.profile) {
        const profile = {
          ...response.data.profile,
          roleName: response.data.profile.role.value,
          role: response.data.profile.role.key,
        }
        this.store.dispatch(SetProfile({profile}));
      }
      if (response.data.token) {
        this.commonService.setAuthenticationToken(response.data.token);
      }

      this.router.navigate([`/${roleUrlMap[response.data.role]}`]);
      this.store.dispatch(StopRegistrationLoading());
      return false;
    }

    if (onGoingStep <= step['step-5'] && onGoingStep >= step['step-1']) {
      this.router.navigate([`auth/register/step-${onGoingStep}`]);
    }

    if (onGoingStep === step['step-warning']) {
      this.router.navigate([`auth/step-warning`])
    }

    this.store.dispatch(StopRegistrationLoading());
    return false;
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
